import styled from 'styled-components';
import { zIndex } from 'styles';
import { rem } from 'polished';

export const Wrapper = styled.div`
  display: flex;
  position: relative;
  height: 100%;
  z-index: ${zIndex.dropdown};
`;

export const DropdownMenuPopover = styled.div<{ isOpen: boolean }>`
  background-color: ${({ theme }) => theme.colors.background.card};
  position: absolute;
  left: 0;
  transform: translateY(${({ isOpen }) => (isOpen ? '100%' : '98%')});
  bottom: -8px;
  transition: all 0.4s cubic-bezier(0.25, 0.1, 0.25, 1);
  opacity: ${({ isOpen }) => (isOpen ? '1' : '0')};
  pointer-events: ${({ isOpen }) => (isOpen ? 'auto' : 'none')};
  box-shadow:
    ${rem(0)} ${rem(3)} ${rem(6)} ${rem(-2)}
      ${({ theme }) => theme.colors.boxShadow},
    ${rem(0)} ${rem(6)} ${rem(12)} ${rem(-3)}
      ${({ theme }) => theme.colors.boxShadow};
  border-radius: ${rem(16)};
  padding: ${rem(8)} ${rem(16)};
  width: ${rem(185)};
`;

export const DropdownMenuList = styled.ul`
  padding: 0;
  margin: 0;
  list-style-type: none;

  a:hover {
    color: inherit;
  }
`;
